export default __webpack_public_path__ + "static/media/jalu.883b6cdb.png";